<script lang='ts'>
  import Modal from '@shared/svelte/Components/Modal.svelte'
  import ProductChooser from '@shared/svelte/ProductChooser/ProductChooser.svelte';
  import type { ProductChooserOptionsType } from '@shared/types/Filters'
  import type { Storefront } from '@shared/types/Storefront'
  export let shouldShowProductChooser : boolean;
  export let onCloseProductChooser: any;
  export let productChooserOptions:ProductChooserOptionsType={};

  export let callbacks: any;
  export let storefront: Storefront=null;
  export let onSelectProduct: any=null;
  export let selectMultipleChoices : object = {};
  let copySelectMultiple = {};
  $: {
    copySelectMultiple = Object.assign({}, selectMultipleChoices);
  }

  function onSelectProductWrapper(plid: any) {
    shouldShowProductChooser = false;
    onSelectProduct(plid)
  }
</script>

<Modal bind:show={shouldShowProductChooser} closeOnBackgroundClick={false} fizzModal={true}>
  <ProductChooser onSelectProduct={onSelectProductWrapper}
    productLines={storefront.catalog} selectMultipleChoices={copySelectMultiple}
    pullFilters={callbacks.pullAvailableFilters}
    pullProductLines={callbacks.pullProductLines} {productChooserOptions}
    {onCloseProductChooser}></ProductChooser>
</Modal>